export default "__VITE_ASSET__DanYoxqZ__"